import React from 'react';
import clsx from 'clsx';
import { CircularProgress } from '@material-ui/core';
import { useGetURLParamEntityIdAsNumber, useGetURLParamEntityIdAsString } from '../../utils/utils';
import { useSelectProject } from '../../utils/dataStateHooks';
import { useRitzTranslation } from '../../utils/customHooks';
import { InvestigateAlertContainer } from '.';



/**
 * This is a page that display all alerts.
 */
export const InvestigateAlertPage: React.FC = () => {

    // Get the params from the URL
    const projectId = useGetURLParamEntityIdAsNumber('projectId');
    const alertId = useGetURLParamEntityIdAsString('alertId');
    const project = useSelectProject(projectId);
    const { trans } = useRitzTranslation(project);



    return (
        <div className={clsx('page-main-content')}>
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.investigate_alert')}
                    </div>
                    <div className="page-subtitle">
                        {trans('page.subtitle.investigate_alert')}
                    </div>
                </div>
            </div>

            {projectId && alertId ? (
                <InvestigateAlertContainer
                    projectId={projectId}
                    alertId={alertId}
                />
            ) : (
                <CircularProgress />
            )}
        </div>
    );
};
